// import Search from "../Search/Search";
const ar = {
  dir: "rtl",
  langs: {
    en: "الأنجليزية",
    ar: "العربية",
  },
  scrollTop: "أعلى",
  textAlign: "right",
  navbar: {
    navLogo: "بوابة التجارة",
    navLinks: {
      link1: "التجارة والأسواق",
      link2: {
        title: "ملف المدينة",
        subLinks: {
          link1: "جميع الدول",
          link2: "اضافة دولة",
        },
      },
      link3: "ملف الشركة",
    },
  },
  mainWebPageHead: "مستشار",
  searchControl: {
    title: "أفضل البلدان للتجارة",
    desc: " حدد <strong> أهم البلدان الشريكة  </strong> لاستيراد أو تصدير أي منتج معين (موضحة في رقم تصنيف النظام المنسق) باستخدام معالج أفضل البلدان للتجارة. المصدر: قاعدة البيانات الإحصائية للأمم المتحدة لمعرفة المزيد عن التغطية والقيود المفروضة على البيانات المقدمة ، يرجى الرجوع إلى:",
    searchForm: {
      labelHead: "اتريد أن:",
      labelInput1: "تصدر",
      labelInput2: "تستورد",
      industryHolder: "اختر مجال عملك:",
      sectorHolder: "اختر قطاعك:",
      searchInput: "بحث",
    },
  },
  tabs: {
    tabsBtn: "التجارة والأسواق",
    tab1: "اكتشف أسواق منتجاتك",
    tab2: "تنمية التجارة",
  },
  addCountry: {
    title: "اضافة دولة",
  },
  editCountry: {
    title: "تعديل دولة",
  },
  AllCountries: {
    title: "جميع الدول",
  },
  CompanyProfile: {
    title: "ملف الشركة",
  },
  footer: {
    mainFooter: {
      title: "دعنا نحسن عملك!",
      desc: "لوريم ايبسوم دولار سيت أميت ,كونسيكتيتور أدايبا يسكينج أليايت,سيت دو أيوسمود تيمبور أنكايديديونتيوت لابوري ات دولار ماجنا أليكيوا . يوت انيم أد مينيم فينايم,كيواس نوستريد أكسير سيتاشن يللأمكو لابورأس نيسي يت أليكيوب أكس أيا كوممودو كونسيكيوات . ديواس أيوتي أريري دولار إن ريبريهينديرأيت فوليوبتاتي فيلايت أيسسي كايلليوم دولار أيو  نيولا باراياتيور. أيكسسيبتيور ساينت أوككايكات كيوبايداتات نون بروايدينت ,سيونت ان كيولبا كيو أوفيسيا ديسيريونتموليت انيم أيدي ايست لابوريوم.",
      btn: "تواصل معنا اليوم",
    },
    subFooter: {
      copyRights: "&copy; The7 Business - 2020. جميع الحقوق محفوظة.",
    },
  },
};
export default ar;
